import { AppStoreButton } from '../common/AppStoreButton/AppStoreButton';
import Styles from './MobileAppLinks.module.scss';

interface OwnProps {
  message: string;
  className?: string;
}

export const MobileAppLinks = (props: OwnProps) => {
  const style = props.className || Styles.mobileAppLinks;

  return (
    <div className={style}>
      <p>{props.message}</p>

      <div>
        <AppStoreButton appStore={'Apple'} />
        <AppStoreButton appStore={'Google'} />
      </div>
    </div>
  );
};
